<template>
  <router-link :to="link" role="button" class="button">
    <font-awesome-icon class="control-icon control-icon--left" v-if="icon" :icon="`${icon}`" />
    <span><slot></slot></span>
  </router-link>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: ['link', 'icon']
};
</script>
